import { db } from '../db/indexeddb';
import axios from 'axios';
import { API_ENDPOINT } from '../../services/api/resources';


export class OfflinePasswordRepository {

  async getFromCache(userToken, deviceId) {
    const rows = await db.offlinePasswords
      .where('[user_token+device_id]')
      .equals([userToken, deviceId])
      .toArray();

    return rows.map(r => r.data);
  }

  async saveToCache(passwords) {
    await db.transaction('rw', db.offlinePasswords, async () => {
      await db.offlinePasswords.clear();

      const data = passwords.map(p => ({
        user_token: p.user_token,
        device_id: p.device_id,
        version: p.version,
        active: p.active,
        data: p,
        lastSynced: Date.now(),
      }));

      await db.offlinePasswords.bulkAdd(data);
    });

    console.log(`✅ Cached ${passwords.length} offline passwords`);
  }

  async syncFromAPI(authToken, userToken, deviceId,userType) {
    console.log(userType,"userType")
    const res = await axios.post(
      API_ENDPOINT.offline_password_list,
      {
        user_type:userType, 
        user_token: userToken,
        device_id: deviceId,
      },
      { headers: { Authorization: `Bearer ${authToken}` } }
    );

    const data = (res.data?.response || []).filter(d => d.active);

    await this.saveToCache(data);

    return data;
  }
}

export const offlinePasswordRepository =
  new OfflinePasswordRepository();
